import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import StatsActions from '../actions/stats.actions';

export function* getMyActivityLevelRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getMyActivityLevel(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getMyActivityLevelSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get activity level', response);
    yield put(StatsActions.getMyActivityLevelFailure());
  }
}

export function* getMyInfractionsRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getMyInfractions(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getMyInfractionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get activity level', response);
    yield put(StatsActions.getMyInfractionsFailure());
  }
}

export function* getInfractionsDetailsRequest(api, action) {
  const { userId, startDate, endDate, timezoneOffset, currentPage, pageSize, search } = action;
  const response = yield api.getUserInfractions(
    userId,
    startDate,
    endDate,
    timezoneOffset,
    currentPage,
    pageSize,
    search,
  );
  if (response && response.ok) {
    yield put(StatsActions.getInfractionsDetailsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get infractions details', response);
    yield put(StatsActions.getInfractionsDetailsFailure());
  }
}

export function* getMySpottedVehiclesRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getMySpottedVehicles(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getMySpottedVehiclesSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get spotted vehicles', response);
    yield put(StatsActions.getMySpottedVehiclesFailure());
  }
}

export function* getMyRepossessionsRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getMyRepossessions(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getMyRepossessionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get repossessions', response);
    yield put(StatsActions.getMyRepossessionsFailure());
  }
}

export function* getMyHoursWorkedRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getMyHoursWorked(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getMyHoursWorkedSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get shift hours worked', response);
    yield put(StatsActions.getMyHoursWorkedFailure());
  }
}

export function* getDayShiftsRequest(api, action) {
  const { userId, date, timezoneOffset } = action;
  const response = yield api.getDayShifts(userId, date, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getDayShiftsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get day shifts', response);
    yield put(StatsActions.getDayShiftsFailure());
  }
}

export function* getDayExtraneousTimesRequest(api, action) {
  const { userId, date, timezoneOffset } = action;
  const response = yield api.getDayExtraneousTimes(userId, date, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getDayExtraneousTimesSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get extraneous times', response);
    yield put(StatsActions.getDayExtraneousTimesFailure());
  }
}

export function* getMyCommissionsRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getMyCommissions(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getMyCommissionsSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get commissions', response);
    yield put(StatsActions.getMyCommissionsFailure());
  }
}

export function* getMyMissedOpportunitiesRequest(api, action) {
  const { startDate, endDate, timezoneOffset } = action;
  const response = yield api.getMyMissedOpportunities(startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(StatsActions.getMyMissedOpportunitiesSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to get missed opportunities', response);
    yield put(StatsActions.getMyMissedOpportunitiesFailure());
  }
}
